//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    constants: {
        rowsPerPageOptions: [5, 10, 20],
    },

    props: {
        columns: Array,
        data: Array,
        isRowGreyFn: Function,
        paginate: Boolean,
        initialRowsPerPage: {
            type: Number,
            default: 10,
        },
        noDataLabel: String,
    },

    data() {
        return {
            pagination: {
                rowsPerPage: this.initialRowsPerPage,
            },
        };
    },

    computed: {
        processedColumns() {
            return this.columns.map(col => ({
                ...col,
                align: col.align || 'left',
            }));
        },
        noDataLabelShown() {
            return !this.data.length && this.noDataLabel;
        },
    },

    watch: {
        paginate: {
            handler(val) {
                // Show all rows if pagination turned off, initial number of rows otherwise
                this.pagination.rowsPerPage = !val ? 0 : this.initialRowsPerPage;
            },
            immediate: true,
        },
    },

    methods: {
        getPaginationLabel(from, to, total) {
            return `Zobrazuji ${from}-${to} z ${total}`;
        },
        onRowClick(ev, row) {
            this.$emit('row-click', ev, row);
        },
    },
};
